// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__bgRTh","signupButton":"Pagination_signupButton__Fcg7K"};